import { api } from 'common';

import { TextBlockFormFields } from './FormFields';
import { textBlockDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const textBlockConfig: BlockConfigProps<api.FlowDefinition.TextBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'text',
  defaultConfig: { text: '' },
  configFields: {
    schema: api.FlowDefinition.TextBlockConfigSchema,
    getLanguageFieldValues: (config) => ({
      [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.text],
    }),
    FormFields: TextBlockFormFields,
  },
  mockDataType: 'string',
  documentationMarkdown: textBlockDocumentationMarkdown,
};
